import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["scope"];
import PropTypes from 'prop-types';
import React, { forwardRef, useContext } from 'react';
import { TableHeaderCellContext } from './TableHeaderCell.context';
import { StyledTableHeaderCell } from './TableHeaderCell.styles';

/**
 * A native [`<th>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/td) element.
 *
 * @since 8.0.0
 */
export var TableHeaderCell = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var scope = _ref.scope,
    rest = _objectWithoutProperties(_ref, _excluded);
  var context = useContext(TableHeaderCellContext);
  var headerScope = scope || (context.parent === 'body' ? 'row' : 'col');
  return /*#__PURE__*/React.createElement(StyledTableHeaderCell, _extends({
    as: "th",
    ref: forwardedRef,
    scope: headerScope
  }, rest));
});
TableHeaderCell.displayName = 'Table.HeaderCell';
TableHeaderCell.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Tells assistive technologies whether this is a column header or a row header.
   * Unless a value is provided, <Table.HeaderCell> will automatically be assigned
   * a `scope="col"` or `scope="row"` attribute based on its parent.
   */
  scope: PropTypes.oneOf(['row', 'col', 'rowgroup', 'colgroup', 'auto'])
} : {};
TableHeaderCell.defaultProps = {
  scope: undefined
};